/* Baltic Dew: product form rules for rings and plugs/tunnels.
   - Add to cart is blocked until every required field (size, width, style, colour preference) is filled.
   - Ready-stock plugs (template "tunnels"): no wood colour pre-selected; blocked until one is picked.
   - Made-to-order plugs: the Size price band (8–50mm / 51mm and over) must match the typed size.
   Works on product pages, the sticky add-to-cart bar and the quick-add pop-up. */
(function () {
  if (window.bdRequiredGuard) return;
  window.bdRequiredGuard = true;

  var COLOUR_OPTION = 'Wood colour';
  var SIZE_OPTION = 'Size', LOW = '8–50mm', HIGH = '51mm and over', LIMIT = 50;
  var RED = '#b3261e';

  /* ---------- styles ---------- */
  var css = [
    /* show our custom fields inside the quick-add pop-up (Horizon hides non-standard blocks there) */
    '.quick-add-modal__content .product-details div:has([name^="properties["]):not(.group-block, .group-block-content, :has(.group-block-content)),',
    '.quick-add-modal__content .product-details div:has([name^="properties["]):not(.group-block, .group-block-content, :has(.group-block-content)) :not(style, script, svg, svg *, .svg-wrapper, #bd-size-warning) { display: block !important; }',
    '.quick-add-modal__content .product-details div:has([name^="properties["]):not(.group-block, .group-block-content, :has(.group-block-content)) { margin-top: 12px; }',
    '.quick-add-modal__content .product-details select, .quick-add-modal__content .product-details input.field__input { width: 100%; max-width: 22rem; height: 3.25rem; padding: 0 1rem; border: 2px solid #303030; border-radius: 12px; background: #f5ecdd; color: #303030; font: inherit; box-sizing: border-box; }',
    '.quick-add-modal__content .product-details .form__label { margin: 0 0 0.4rem; font-weight: 600; }',
    '.quick-add-modal__content .product-details .bd-size-help { margin-top: 0.4rem; font-size: 0.875rem; }',
    /* no colour picked yet: hide Horizon's sliding highlight so no button looks selected */
    '.bd-colour-unpicked .variant-option__button-label__pill { opacity: 0 !important; }',
    '.bd-colour-unpicked .variant-option__button-label { color: #303030 !important; }',
    '.bd-required-msg { color: ' + RED + '; font-weight: 600; font-size: 0.875rem; margin: 0.4rem 0 0; }',
    /* free UK shipping bar: hide for anyone whose shopping country is not the UK (e.g. EU visitors Shopify treats as the UK market) */
    '.bd-not-uk .bd-ship-bar { display: none !important; }'
  ].join('\n');
  // UK-only shipping bar: hide it unless the visitor's shopping country AND detected location are the UK.
  // (With the EU market switched off, Shopify puts EU visitors in the UK market, so Shopify.country alone isn't enough.)
  function markNonUk(country) {
    if (country && country !== 'GB') document.documentElement.classList.add('bd-not-uk');
  }
  try { if (window.Shopify && Shopify.country) markNonUk(Shopify.country); } catch (err) {}
  (function () {
    var cached = null;
    try { cached = sessionStorage.getItem('bdGeoCountry'); } catch (err) {}
    if (cached) { markNonUk(cached); return; }
    fetch('/browsing_context_suggestions.json').then(function (r) { return r.json(); }).then(function (j) {
      var c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      if (!c) return;
      try { sessionStorage.setItem('bdGeoCountry', c); } catch (err) {}
      markNonUk(c);
    }).catch(function () {});
  })();

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  (document.head || document.documentElement).appendChild(styleEl);

  /* ---------- helpers ---------- */
  function scopeOf(node) {
    return (node && node.closest && node.closest('dialog')) || document.querySelector('main') || document;
  }
  function isEmpty(el) {
    if (el.disabled || !el.required) return false;
    if (el.type === 'checkbox') return !el.checked;
    return String(el.value || '').trim() === '';
  }
  function fieldWrap(el) {
    return el.closest('.bd-size-field, .bd-ring-field, .product-form__input, .field, fieldset') || el.parentElement;
  }
  function setMsg(anchor, key, text) {
    if (!anchor || !anchor.parentElement) return;
    var m = anchor.parentElement.querySelector('.bd-required-msg[data-for="' + key + '"]');
    if (!text) { if (m) m.remove(); return; }
    if (!m) {
      m = document.createElement('p');
      m.className = 'bd-required-msg';
      m.setAttribute('role', 'alert');
      m.setAttribute('data-for', key);
      anchor.insertAdjacentElement('afterend', m);
    }
    m.textContent = text;
  }
  function markField(el, text) {
    if (text) {
      el.style.setProperty('border-color', RED, 'important');
      el.setAttribute('aria-invalid', 'true');
    } else {
      el.style.removeProperty('border-color');
      el.removeAttribute('aria-invalid');
    }
    setMsg(fieldWrap(el), el.name, text);
  }
  function scrollTo(el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (err) {} }, 300);
  }

  /* ---------- colour must be picked (ready-stock plugs) ---------- */
  var mainEl = document.querySelector('main[data-template]');
  var mainNeedsColour = !!(mainEl && mainEl.dataset.template === 'product.tunnels' && !/[?&]variant=/.test(location.search));
  var modalNeedsColour = false;

  function colourRadios(scope) {
    return scope.querySelectorAll('input[type="radio"][data-option-name="' + COLOUR_OPTION + '"]');
  }
  function needsColour(scope) {
    if (!scope || scope.dataset && scope.dataset.bdColourPicked === '1') return false;
    if (scope.tagName === 'DIALOG') return modalNeedsColour;
    return mainNeedsColour;
  }
  function clearColour(scope) {
    if (!needsColour(scope)) return;
    var radios = colourRadios(scope);
    if (!radios.length) return;
    radios.forEach(function (r) {
      r.checked = false;
      r.setAttribute('data-current-checked', 'false');
      var fs = r.closest('fieldset');
      if (fs) fs.classList.add('bd-colour-unpicked');
    });
  }
  function refreshColour() {
    if (mainNeedsColour && mainEl) clearColour(mainEl);
    document.querySelectorAll('dialog').forEach(clearColour);
  }

  // Which card opened the pop-up?
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.quick-add__button--choose');
    if (!b) return;
    var q = b.closest('quick-add-component');
    modalNeedsColour = !!(q && q.getAttribute('data-bd-colour-required') === 'true');
    document.querySelectorAll('dialog').forEach(function (d) { delete d.dataset.bdColourPicked; });
    if (modalNeedsColour) [300, 800, 1500, 3000].forEach(function (t) { setTimeout(refreshColour, t); });
  }, true);

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; refreshColour(); });
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshColour);
  else refreshColour();
  window.addEventListener('pageshow', refreshColour);

  /* ---------- size band (made-to-order plugs) ---------- */
  function sizeInput(scope) { return scope.querySelector('[name="properties[Enter Your Size]"]'); }
  function sizeVal(input) {
    var m = String(input.value).replace(',', '.').match(/\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }
  function bandRadio(scope, v) {
    return scope.querySelector('input[type="radio"][data-option-name="' + SIZE_OPTION + '"][value="' + v + '"]');
  }
  function bandSelected(scope) {
    var r = scope.querySelector('input[type="radio"][data-option-name="' + SIZE_OPTION + '"]:checked');
    return r ? r.value : null;
  }
  function syncBand(scope) {
    var input = sizeInput(scope);
    if (!input) return;
    var n = sizeVal(input);
    if (isNaN(n)) return;
    var want = n > LIMIT ? HIGH : LOW;
    if (bandSelected(scope) !== want) { var r = bandRadio(scope, want); if (r) r.click(); }
  }

  /* ---------- live updates ---------- */
  function onEdit(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[type="radio"][data-option-name="' + COLOUR_OPTION + '"]')) {
      var scope = scopeOf(t);
      if (scope.dataset) scope.dataset.bdColourPicked = '1';
      var fs = t.closest('fieldset');
      if (fs) { fs.classList.remove('bd-colour-unpicked'); setMsg(fs, 'colour', ''); }
      scope.querySelectorAll('fieldset.bd-colour-unpicked').forEach(function (f) { f.classList.remove('bd-colour-unpicked'); });
      return;
    }
    if (t.name && t.name.indexOf('properties[') === 0 && !isEmpty(t)) markField(t, '');
    if (e.type === 'change' && t.name === 'properties[Enter Your Size]') syncBand(scopeOf(t));
  }
  document.addEventListener('input', onEdit, true);
  document.addEventListener('change', onEdit, true);

  // Forms without novalidate (e.g. the pop-up) are stopped by the browser first: show our message instead of its bubble.
  var invalidTimer = null;
  document.addEventListener('invalid', function (e) {
    var el = e.target;
    if (!el || !el.name || el.name.indexOf('properties[') !== 0) return;
    e.preventDefault();
    markField(el, el.tagName === 'SELECT' ? 'Please choose an option before adding to cart.' : 'Please fill this in before adding to cart.');
    if (!invalidTimer) {
      invalidTimer = setTimeout(function () { invalidTimer = null; }, 100);
      scrollTo(el);
    }
  }, true);

  /* ---------- the check (window capture runs before Horizon's own submit handler) ---------- */
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
    var scope = scopeOf(form);
    var first = null;

    // 1. required fields
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.name && el.name.indexOf('properties[') === 0 && isEmpty(el)) {
        markField(el, el.tagName === 'SELECT' ? 'Please choose an option before adding to cart.' : 'Please fill this in before adding to cart.');
        if (!first) first = el;
      }
    }

    // 2. colour picked
    if (/^BuyButtons-/.test(form.getAttribute('id') || '') && needsColour(scope)) {
      var r = colourRadios(scope)[0];
      var fs = r && r.closest('fieldset');
      if (fs) {
        setMsg(fs, 'colour', 'Please choose a colour before adding to cart.');
        if (!first) first = fs;
      }
    }

    // 3. size band matches the typed size
    if (!first) {
      var input = sizeInput(scope);
      if (input && form.elements.namedItem && form.elements.namedItem('properties[Enter Your Size]')) {
        var n = sizeVal(input), have = bandSelected(scope);
        if (!isNaN(n) && have) {
          var want = n > LIMIT ? HIGH : LOW;
          if (have !== want) {
            var br = bandRadio(scope, want);
            if (br) br.click();
            markField(input, 'Your size is ' + n + 'mm, so the size option has been changed to "' + want + '". Please check the price and add to cart again.');
            input.style.removeProperty('border-color');
            first = input;
          }
        }
      }
    }

    if (!first) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    scrollTo(first);
  }, true);
})();
